import React from "react";
import { FiCheckCircle, FiXCircle } from "react-icons/fi";
import "./ToastHost.css";

const ToastContext = React.createContext(null);

export function useToast() {
  return React.useContext(ToastContext);
}

export default function ToastHost({ children }) {
  const [toast, setToast] = React.useState(null);

  const push = React.useCallback((type, msg) => {
    setToast({ type, msg });
    window.clearTimeout(window.__toastTimer);
    window.__toastTimer = window.setTimeout(() => setToast(null), 1700);
  }, []);

  return (
    <ToastContext.Provider value={{ push }}>
      {children}
      {toast ? (
        <div className={`toastHost ${toast.type}`}>
          <div className="toastIcon">
            {toast.type === "success" ? <FiCheckCircle /> : <FiXCircle />}
          </div>
          <div className="toastMsg">{toast.msg}</div>
        </div>
      ) : null}
    </ToastContext.Provider>
  );
}